/* @flow */
import BoxBody from 'components/BoxBody.jsx';
import DialogContent from 'components/DialogContent.jsx';
import EmailForm from 'components/EmailForm.jsx';
import React from 'react';
import RequireUser from 'components/mixins/RequireUser';

const SetupEmail = React.createClass({
  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  mixins: [
    RequireUser,
  ],

  onSave() {
    this.context.router.push('/');
  },

  render() {
    return (
      <DialogContent
        size="small"
        full
        title={'What is your email address?'}
        subtext={'This will be your primary email address for Remind.'}>
        <BoxBody divided>
          <EmailForm onSave={this.onSave} />
        </BoxBody>
      </DialogContent>
    );
  },
});

export default SetupEmail;



// WEBPACK FOOTER //
// ./src/setup/components/SetupEmail.jsx